import type { InputProps } from "@chakra-ui/react";
import { Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { forwardRef } from "react";
import type { UseFormRegisterReturn } from "react-hook-form";
import type { FormContainerProps } from "./form-container";
import FormContainer from "./form-container";

interface InputFieldProps extends UseFormRegisterReturn, FormContainerProps {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  chakraInputProps?: InputProps;
  onPressEnter?(): void;
}

const InputField = forwardRef<HTMLInputElement, InputFieldProps>((props, ref) => {
  const {
    onChange,
    onBlur,
    name,
    onPressEnter,
    rightIcon,
    leftIcon,
    chakraInputProps,
    ...formContainerProps
  } = props;
  return (
    <FormContainer {...formContainerProps}>
      <InputGroup size={chakraInputProps?.size}>
        {leftIcon && <InputLeftElement>{leftIcon}</InputLeftElement>}
        <Input
          {...chakraInputProps}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          onKeyPress={(e) => {
            if (e.key === "Enter" && onPressEnter) {
              onPressEnter();
            }
          }}
        />
        {rightIcon && <InputRightElement>{rightIcon}</InputRightElement>}
      </InputGroup>
    </FormContainer>
  );
});

InputField.displayName = "InputField";

export default InputField;
